import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RTL_LANGUAGES = [];

export default function LanguageSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.resolvedLanguage || i18n.language;

    document.documentElement.lang = lang === 'jp' ? 'ja' : lang;

    document.documentElement.dir = RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr';
  }, [i18n.language, i18n.resolvedLanguage]);

  return null;
}
